import React, { useState } from 'react';
import { Button, Heading, Text, VStack } from '@chakra-ui/react';
import { ForgotPasswordForm } from './ForgotPasswordForm';
import { BasicLayout } from 'layouts';
import { FormWrapper } from 'components';
import { ReactComponent as LockedImage } from 'assets/locked.svg';
import { ReactComponent as UnlockedImage } from 'assets/unlocked.svg';
import { useHistory } from 'react-router-dom';

const ForgotPassword: React.FC = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const history = useHistory();

  return (
    <BasicLayout backPath="/login" showLogo>
      <FormWrapper
        aboveForm={
          <VStack textAlign="center" spacing={5}>
            <Heading as="h1" pt={[0, 8]} size="xl" textAlign="center">
              {formSubmitted ? 'Email has been sent!' : 'Can’t log in?'}
            </Heading>
            <Text maxW="sm">
              {formSubmitted
                ? 'Check your inbox and click on the recovery link to regain access to your account.'
                : 'That’s okay, it happens! Enter your email below and we’ll send you a recovery link.'}
            </Text>
          </VStack>
        }
        form={
          formSubmitted ? (
            <Button
              onClick={() => history.push('/login')}
              variant="blue"
              size="lg"
              isFullWidth
            >
              Return to login screen
            </Button>
          ) : (
            <ForgotPasswordForm callback={() => setFormSubmitted(true)} />
          )
        }
        formImage={
          formSubmitted ? (
            <UnlockedImage height="100%" />
          ) : (
            <LockedImage height="100%" />
          )
        }
      />
    </BasicLayout>
  );
};

export default ForgotPassword;
